import Router from 'components/routes/routers/contract/lifeInsurance/LifeInsuranceContractRouter';
import Creation, { formValidate } from './Creation';
import initialValues from '../common/utils/initialValues';

const lifeInsurance = {
    // human readable title for this kind of product
    label: 'Assurance vie',
    icon: 'line-chart',
    // it may eventually not be available (the RIP is given as first argument)
    isAvailable: () => true,
    // it may have additional fields (the RIP is given as property)
    formComponent: Creation,
    // it may have to validate data (must be a validator signature)
    formValidation: (errors, values, props) => formValidate(values, props, errors),
    // it may have initial values
    initialValues,
    // and an entry point for the form
    router: Router,
};

export default lifeInsurance;
